import { render, staticRenderFns } from "./GoClassDetail.vue?vue&type=template&id=50616197&scoped=true"
import script from "./GoClassDetail.vue?vue&type=script&lang=js"
export * from "./GoClassDetail.vue?vue&type=script&lang=js"
import style0 from "./GoClassDetail.vue?vue&type=style&index=0&id=50616197&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50616197",
  null
  
)

export default component.exports